import { queryFlightListApi, queryFlightFareRule, priceVerifyApi, queryFlightListFareRule } from '@/apis/flights';

// import type { FlightQueryParamLo, FlightFormatResultVo } from '@/logic/flights/model';
import type { FlightListAo, FlightFraeRuleAo } from '@/apis/flights/model';

// 接口调用,查询航班列表
export const getFlightList = async (params: any) => {
	const res: FlightListAo = await queryFlightListApi(params);
	return res;
};

export const getFlightFareRule = async (sessionId: string) => {
	const res: FlightFraeRuleAo = await queryFlightFareRule({ sessionId });
	return res;
};

export const postFlightFareRule = async (params: { cid: string, data: string; }) => {
	const res: FlightFraeRuleAo = await queryFlightListFareRule(params);
	return res;
};

export const getFlightPriceVerify = async (cid: string, data: string, returnSearch?: boolean, otaReferenceId?: string) => {
	const res: any = await priceVerifyApi({ cid, data, returnSearch, otaReferenceId });
	return res;
};


